module.exports = __webpack_public_path__ + "static/1606077576667 1-2e47ef79534484046d548b150cde4e83.png";